import {NgModule} from '@angular/core';
import {EtsDraggableDirective} from './ets-draggable.directive';

/**
 * Standalone module exposing {@link EtsDraggableDirective}. Kept independent (no other imports) so the
 * OPG / APG / Hedging-Grid panel modules can each import it directly, without leaning on the tangled
 * inter-module chain (APG -> HedgingGrid -> OPG) or any copilot feature coupling.
 */
@NgModule({
    declarations: [EtsDraggableDirective],
    exports: [EtsDraggableDirective]
})
export class EtsDraggableModule {
}
